import { Route } from '@angular/router';
import { TenderInvitationComponent } from '../../../../pages';
import { TenderCoverLetterResolver, TenderDocumentsResolver, TenderRequestedDocumentsResolver } from '../../../resolvers';

export const tenderInvitationRoute: Route = {
    path: 'invitation',
    component: TenderInvitationComponent,
    //canActivate: [TenderStatusGuard],
    resolve: {
        coverLetter: TenderCoverLetterResolver,
        documents: TenderDocumentsResolver,
        requestedDocuments: TenderRequestedDocumentsResolver,
    }
};
